import { accessToken } from "./supabase";

export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) { super(message); }
}

/** fetch a /api/* con el JWT de Supabase. Lanza ApiError con el mensaje en español del servidor. */
export async function api<T>(path: string, init: RequestInit & { json?: unknown } = {}): Promise<T> {
  const token = await accessToken();
  if (!token) throw new ApiError(401, "NO_AUTENTICADO", "Tu sesión terminó. Vuelve a entrar.");
  const headers: Record<string, string> = { Authorization: `Bearer ${token}`, ...(init.headers as Record<string, string> | undefined) };
  let body = init.body;
  if (init.json !== undefined) { headers["Content-Type"] = "application/json"; body = JSON.stringify(init.json); }
  const res = await fetch(path, { ...init, headers, body });
  if (!res.ok) {
    let code = String(res.status), message = "Ocurrió un error.";
    try { const j = (await res.json()) as { error?: { code?: string; message?: string } }; code = j.error?.code ?? code; message = j.error?.message ?? message; } catch { /* sin cuerpo */ }
    throw new ApiError(res.status, code, message);
  }
  return (await res.json()) as T;
}

export async function apiRaw(path: string, init: RequestInit = {}): Promise<Response> {
  const token = await accessToken();
  if (!token) throw new ApiError(401, "NO_AUTENTICADO", "Tu sesión terminó. Vuelve a entrar.");
  return fetch(path, { ...init, headers: { Authorization: `Bearer ${token}`, ...(init.headers as Record<string, string> | undefined) } });
}
